<template>
	<div class="policy">
		<div class="policyCon">
			<searchBox :type='3' place='输入关键字' @search='search'></searchBox>

			<div class="policyType">
				<classType :type='3'></classType>
				<div class="policyCode">
					<downCode></downCode>
				</div>
			</div>

			<div class="lookUp">
				<div class="title">
					智能推荐
				</div>
				<div class="label">
					<div class="li" v-for="(item,index) of recomList" :key="index" :class="{select:recomIndex==index}"
						@click="selectClass(item.id,index)">
						{{item.title}}
					</div>
				</div>
			</div>

			<div style="margin-bottom: 48px;">
				<policyItem :list='list'></policyItem>
			</div>

			<div class="lookUp">
				<div class="title">
					实时
				</div>
				<div class="label">
					<div class="li" v-for="(item,index) of realList" :key="index" :class="{select:real==item.id}"
						@click="goList(index,item.id)">
						{{item.name}}
					</div>
				</div>
			</div>

			<div class="data">
				<div class="statis">
					<div class="title">
						统计
					</div>
					<div v-if="statisticsInfo" class="statisData">
						<div class="li">
							<div class="num">
								{{statisticsInfo.policy_count}}
							</div>
							<div class="label">
								立项总数(项)
							</div>
						</div>
						<div class="li">
							<div class="num">
								{{statisticsInfo.policy_apply_count}}
							</div>
							<div class="label">
								申报人数(个)
							</div>
						</div>
						<div class="li">
							<div class="num">
								{{calcAmount(statisticsInfo.total_amount).amount}}
							</div>
							<div class="label">
								发放金额({{calcAmount(statisticsInfo.total_amount).text}})
							</div>
						</div>
					</div>
				</div>

				<div class="general">
					<div class="title">
						榜单
					</div>
					<div class="generalUl">
						<div v-for="(item,index) of rankList" :key="index" class="li" v-if="index<4">
							<div class="liCon">
								{{item.company_name}}
							</div>
							<div class="price">
								{{item.polic_count}} 项
							</div>
						</div>
					</div>
				</div>
				
				<div class="general">
					<div class="title">
						概况
					</div>
					<div class="generalUl">
						<div v-for="(item,index) of generalList" :key="index" class="li" v-if="index<4">
							<div class="liCon">
								{{item.company_name}}
							</div>
							<div class="price">
								{{calcAmount(item.total_amount).amount + calcAmount(item.total_amount).text}}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import searchBox from '@/components/searchBox.vue'
	import downCode from '@/components/downCode.vue'
	import classType from '@/components/classType.vue'
	import policyItem from '@/components/policyItem.vue'
	export default {
		name: 'policy',
		components: {
			searchBox,
			downCode,
			classType,
			policyItem
		},
		data() {
			return {
				loading: false,
				list: [],
				recomIndex: 0,
				recomList: [],
				real: 0,
				realList: [{
						name: '实时数据',
						id: 0
					},
					{
						name: '平台动态',
						id: 2
					},
					{
						name: '资讯公示',
						id: 1
					},
					{
						name: '成功案例',
						id: 3
					},
				],
				statisticsInfo: '',
				generalList: [],
				rankList:[],
			}
		},
		created() {
			// this.getOneClass()
			this.getGeneral()
			this.getStatistics()
			this.getList()
		},
		methods: {
			// 一级分类
			getOneClass() {
				this.$axios.get('/api/client/Policy/getMainClassification').then(res => {
					this.recomList = res.data
					this.getList()
				})
			},
			// 获取推荐
			getList() {
				this.$axios.get('/api/client/Policy/getPolicyRecommend').then(res => {
					if (res.code == 200) {
						this.recomList = res.data
						this.list = this.recomList[this.recomIndex].policy
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			selectClass(id, index) {
				this.recomIndex = index
				this.list = this.recomList[this.recomIndex].policy
			},
			// 统计
			getStatistics() {
				this.$axios.get('/api/client/Policy/getPolicyStatistics').then(res => {
					this.statisticsInfo = res.data
				})
			},
			// 概况
			getGeneral() {
				this.$axios.get('/api/client/Policy/getPolicyOverview').then(res => {
					if(res.code==200){
						this.generalList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
				this.$axios.get('/api/client/Policy/getPolicyRanking').then(res=>{
					if(res.code==200){
						this.rankList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			// 金额换算
			calcAmount(number) {
				number = parseFloat(number);
				if (number >= 100000000) {
					return {
						amount: parseFloat((number / 100000000).toFixed(2)),
						text: '亿元'
					}
				}
				if (number >= 10000) {
					return {
						amount: parseFloat((number / 10000).toFixed(2)),
						text: '万元'
					}
				}
				return {
					amount: parseFloat((number).toFixed(2)),
					text: '元'
				}
			},
			goList(index,id){
				if(index!=0){
					this.$router.push({ name: 'dynamicList',query:{type:id}});
				}
			},
			policyDe(id){
				this.$router.push({ name: 'policyDe',query:{id:id}});
			},
			search(value){
				if(value){
					this.$router.push({ name: 'policySearch', params: { title: value } });
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.policy {
		position: relative;

		.policyCon {
			position: relative;
			z-index: 2;
			width: 1200px;
			margin: 0 auto;
			padding: 48px 0;

			.policyType {
				padding-right: 245px;
				position: relative;
				margin-bottom: 48px;

				.policyCode {
					position: absolute;
					right: 0;
					top: 0;
				}
			}

			.lookUp {
				display: flex;
				align-items: center;
				margin-bottom: 32px;

				.title {
					font-size: 36px;
					color: #151515;
					margin-right: 48px;
					font-weight: bold;
					width: 144px;
				}

				.label {
					display: flex;
					align-items: center;

					.li {
						width: 94px;
						line-height: 34px;
						cursor: pointer;
						font-size: 17px;
						font-weight: bold;
						text-align: center;
						margin-right: 12px;
						border-radius: 8px;
						color: #151515;

						&:hover {
							background-color: #51A190;
							color: #fff;
						}
					}

					.select {
						background-color: #51A190;
						color: #fff;
					}
				}
			}

			.project {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				margin-bottom: 48px;

				.li {
					position: relative;
					width: 390px;
					margin-right: 15px;
					margin-bottom: 16px;
					cursor: pointer;
					&:nth-child(3n) {
						margin-right: 0;
					}

					padding: 16px 22px;
					background-color: #FFF;
					border-radius: 8px;
					box-sizing: border-box;

					.name {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-bottom: 14px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;

					}

					.lis {
						display: flex;
						align-items: center;
						margin-bottom: 4px;
						font-size: 14px;

						&:last-child {
							margin-bottom: 0;
						}

						.icon {
							width: 15px;
							height: 15px;
							margin-right: 3px;
						}
					}

					.button {
						width: 58px;
						line-height: 28px;
						text-align: center;
						background-color: rgba(155, 108, 255, 0.1);
						border-radius: 8px;
						color: #9B6CFF;
						font-size: 13px;
						cursor: pointer;
						transition: all 0.2s;
						position: absolute;
						right: 22px;
						bottom: 16px;

						&:hover {
							background-color: rgba(155, 108, 255, 1);
							color: #fff;
						}
					}
				}
			}

			.data {
				display: flex;
				align-items: center;

				.statis {
					height: 198px;
					color: #151515;
					background-color: #FFF;
					border-radius: 8px;
					padding: 18px 22px;
					// width: 360px;
					flex: 1;
					box-sizing: border-box;
					margin-right: 18px;

					.title {
						font-size: 16px;
						margin-bottom: 42px;
						font-weight: bold;
					}

					.statisData {
						display: flex;
						align-items: center;
						justify-content: space-around;

						.li {
							.num {
								font-size: 18px;
								font-weight: bold;
								margin-bottom: 5px;
								text-align: center;
							}

							.label {
								font-size: 12px;
								text-align: center;
							}
						}
					}
				}

				.general {
					height: 198px;
					color: #151515;
					background-color: #FFF;
					border-radius: 8px;
					padding: 18px 22px 4px;
					box-sizing: border-box;
					flex: 1;
					margin-right: 18px;
					overflow: hidden;
					&:last-child{
						margin-right: 0;
					}
					.title {
						margin-bottom: 14px;
						font-size: 16px;
						font-weight: bold;
					}
					::-webkit-scrollbar {
						width: 4px;
						/*  设置纵轴（y轴）轴滚动条 */
						height: 8px;
						/*  设置横轴（x轴）轴滚动条 */
					}
					/* 滚动条滑块（里面小方块） */
					::-webkit-scrollbar-thumb {
						border-radius: 10px;
						background: rgba(66, 66, 66, 0.1);
					}
					/* 滚动条轨道 */
					::-webkit-scrollbar-track {
						background: rgba(0, 0, 0, 0.1);
						border-radius: 10px;
						margin: 8px 0;
					}
					.generalUl {
						overflow-y: auto;
						height: 100%;
						.li {
							// width: 50%;
							display: flex;
							align-items: center;
							color: #151515;
							font-size: 15px;
							margin-bottom: 14px;
							.liCon {
								width: 238px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								// margin: 0 20px 0 6px;
								font-size: 14px;
							}
							.price{
								flex: 1;
								text-align: right;
								font-size: 14px;
							}
						}
					}
				}
			}
		}
	}
</style>